module.exports = __webpack_public_path__ + "img/platform1.b3d60888.png";